import { Rule } from '../RuleBox'

const tileLockRules: Array<Rule> = [
  {
    details: 'Deposits can always be made into geotokens, but they can only be withdrawn when unlocked.',
    reason:
      'We wanted to make the XYO tokens that were used for recent minting locked up so that the same tokens can not be used to rapidly to mint additional geotokens.',
    summary: 'When minted, a geotoken is locked (no withdrawals)',
  },
  {
    details: 'To unlock the ERC20 and ERC721 vaults in each geotoken, at least two of the children must be minted.',
    reason:
      'It is our estimation that for any given geotoken, there are two geotokens that warrant rapid minting based on proximity in the parent geotoken. Once they are minted, the parent geotoken is unlocked.  The other two can then go to Dutch Auction if their minimum minting deposit is too high.',
    summary: 'A geotoken unlocks once 50% (2/4) of its children are minted',
  },
]

export default tileLockRules
